import graphql__7bce17312c33b3ea0e1e from "./__generated__/ContributionsGridManagerQuery.graphql.js";import { graphql } from "react-relay";
import AppQueryRenderer from "../../AppQueryRenderer";

import ContributionsGrid, { CONTRIBUTIONS_BATCH_SIZE } from "./ContributionsGrid";
import { BoxSpinner } from "../../Utils/Spinner";

const ContributionsGridManager = ({ participativeModuleId }) => {
  const contributionsCount = CONTRIBUTIONS_BATCH_SIZE;
  const commentsCount = 0;

  return (
    <AppQueryRenderer
      query={ContributionsGridManagerQuery}
      variables={{ participativeModuleId, contributionsCount, commentsCount }}
      component={ContributionsGrid}
      loader={<BoxSpinner />}
    />
  );
};

const ContributionsGridManagerQuery = graphql__7bce17312c33b3ea0e1e;

export default ContributionsGridManager;
